import { render } from "./shop_reviews_block.vue?vue&type=template&id=6d954485&scoped=true"
import script from "./shop_reviews_block.vue?vue&type=script&lang=js"
export * from "./shop_reviews_block.vue?vue&type=script&lang=js"

import "./shop_reviews_block.vue?vue&type=style&index=0&id=6d954485&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d954485"]])

export default __exports__